import { PreventUserSelect } from '../styles/PreventUserSelect';
import { TabStyles } from '../styles/TabStyles';

const { Colors, Typography, Sizing, Spacing } = TabStyles;

export const datePickerWidgetStyle: React.CSSProperties = {
  backgroundColor: 'white',
  borderColor: Colors.L5,
  borderRadius: Sizing.BorderRadius,
  borderStyle: 'solid',
  borderWidth: Sizing.BorderWidth,
  boxSizing: 'border-box',
  color: Typography.Color.Primary,
  display: 'inline-block',
  fontSize: Typography.Sizing.Default,
  lineHeight: 'normal',
  padding: Spacing.DefaultSpace,
  ...PreventUserSelect,
};

export const datePickerHeaderStyle: React.CSSProperties = {
  borderBottom: `1px solid ${Colors.F4}`,
  paddingBottom: Spacing.DefaultSpace,
};

export const datePickerBodyStyle: React.CSSProperties = {
  marginTop: Spacing.DefaultSpace,
  marginBottom: Spacing.DefaultSpace,
};

export const datePickerDayOfWeekHeaderStyle: React.CSSProperties = {
  marginTop: Spacing.DefaultSpace,
};

export const datePickerButtonStyle: React.CSSProperties = {
  marginBottom: Spacing.DefaultSpace,
};

const datePickerCellBaseStyle: React.CSSProperties = {
  alignItems: 'center',
  borderRadius: 1,
  boxSizing: 'border-box',
  color: Typography.Color.Primary,
  display: 'inline-flex',
  height: '30px',
  justifyContent: 'center',
  width: '30px',
};

export interface DatePickerCellStyles {
  dayOfWeekColHeader: React.CSSProperties;
  default: React.CSSProperties;
  disabled: React.CSSProperties;
  inOtherMonths: React.CSSProperties;
  isoWeekNum: React.CSSProperties;
  isoWeekNumColHeader: React.CSSProperties;
  selected: React.CSSProperties;
  today: React.CSSProperties;
  todaySelected: React.CSSProperties;
}

export const datePickerCellStyles: DatePickerCellStyles = {
  dayOfWeekColHeader: {
    ...datePickerCellBaseStyle,
    fontWeight: 'bold',
  },
  default: {
    ...datePickerCellBaseStyle
  },
  disabled: {
    textDecoration: 'line-through',
  },
  inOtherMonths: {
    ...datePickerCellBaseStyle,
    color: Typography.Color.Disabled,
  },
  isoWeekNum: {
    ...datePickerCellBaseStyle,
    fontWeight: 'bold',
    marginRight: Spacing.DefaultSpace,
  },
  isoWeekNumColHeader: {
    ...datePickerCellBaseStyle,
    fontWeight: 'bold',
    marginRight: Spacing.DefaultSpace,
  },
  selected: {
    ...datePickerCellBaseStyle,
    backgroundColor: Colors.F4,
  },
  today: {
    ...datePickerCellBaseStyle,
    borderColor: Colors.GoLight,
    borderRadius: Sizing.BorderRadius,
    borderStyle: 'solid',
    borderWidth: Sizing.BorderWidth,
  },
  todaySelected: {
    ...datePickerCellBaseStyle,
    backgroundColor: Colors.F8,
    color: Colors.White,
  },
};
